import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "float-end" };
const _hoisted_4 = { id: "current" };
const _hoisted_5 = { id: "maximum" };
const _hoisted_6 = { class: "float-start mt-2" };
const _hoisted_7 = { class: "d-flex" };
const _hoisted_8 = { class: "checkbox-aligned-buttons" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_10 = { class: "alarm-comments" };
const _hoisted_11 = { class: "mt-2" };
const _hoisted_12 = { class: "fw-bold me-2" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { class: "border p-2" };
const _hoisted_15 = { style: { "white-space": "pre-line" } };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "clearfix" };
const _hoisted_20 = { class: "float-end" };
const _hoisted_21 = { id: "current" };
const _hoisted_22 = { id: "maximum" };
const _hoisted_23 = { class: "float-start mt-2" };
const _hoisted_24 = { class: "d-flex" };
const _hoisted_25 = { class: "checkbox-aligned-buttons" };
const _hoisted_26 = { class: "clearfix d-flex justify-content-center mt-2" };
const _hoisted_27 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_container = _resolveComponent("b-container");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.showModal) = $event)),
        "header-bg-variant": "normal",
        size: "lg",
        onHidden: _ctx.onHidden
    }, {
        title: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("\r\n\t\t\tAlarm Comments\r\n\t\t", -1 /* CACHED */)
            ]))]),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showModal = false))
                }, {
                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                            _createTextVNode(" Close\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        default: _withCtx(() => [
            _cache[34] || (_cache[34] = _createTextVNode()),
            _createVNode(_component_b_container, {
                class: "alarm-comments-container",
                clearfix: ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\tNew comment\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[13] || (_cache[13] = _createTextVNode()),
                            _createVNode(_component_b_form_textarea, _mergeProps(_ctx.commentVal, {
                                name: "notes",
                                modelValue: _ctx.log.notes,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.log.notes) = $event)),
                                rows: "5",
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.comment && _ctx.attemptedSave },
                                maxlength: _ctx.maxCommentLength
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "maxlength"]),
                            _cache[14] || (_cache[14] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getCommentLength(_ctx.log.notes)), 1 /* TEXT */),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_5, "/ " + _toDisplayString(_ctx.maxCommentLength), 1 /* TEXT */)
                            ]),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _ctx.save,
                                        disabled: (_ctx.errors && _ctx.errors.comment) || _ctx.working
                                    }, {
                                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                                _createTextVNode(" Save\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _createVNode(_component_b_button, {
                                        class: "ms-2",
                                        type: "button",
                                        variant: "secondary",
                                        onClick: _ctx.cancel,
                                        disabled: (_ctx.errors && _ctx.errors.comment) || _ctx.working
                                    }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                _createTextVNode(" Cancel\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_b_form_checkbox, {
                                            class: "ms-2",
                                            style: { "padding-top": "8px" },
                                            modelValue: _ctx.log.notifySiteContactGroup,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.log.notifySiteContactGroup) = $event)),
                                            size: "lg"
                                        }, {
                                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNotify\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue"])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _cache[32] || (_cache[32] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_9, [
                        _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "mt-2" }, "History", -1 /* CACHED */)),
                        _cache[31] || (_cache[31] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs.records, (log) => {
                                var _a;
                                return (_openBlock(), _createElementBlock("div", null, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(log.authorName), 1 /* TEXT */),
                                        _cache[26] || (_cache[26] = _createTextVNode()),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.getFormattedDate(log.whenEntered)), 1 /* TEXT */),
                                        _cache[27] || (_cache[27] = _createTextVNode()),
                                        (!_ctx.isEditingLog(log))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createElementVNode("p", _hoisted_15, _toDisplayString(log.notes), 1 /* TEXT */)
                                                ]),
                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                _createElementVNode("a", {
                                                    class: "pointer blue me-2",
                                                    onClick: ($event) => (_ctx.edit(log))
                                                }, "Edit", 8 /* PROPS */, _hoisted_16),
                                                _cache[17] || (_cache[17] = _createTextVNode()),
                                                _createElementVNode("a", {
                                                    class: "pointer blue",
                                                    onClick: ($event) => (_ctx.remove(log))
                                                }, "Remove", 8 /* PROPS */, _hoisted_17)
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                _createVNode(_component_b_form_textarea, {
                                                    name: "notes",
                                                    modelValue: _ctx.editingLog.notes,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.editingLog.notes) = $event)),
                                                    rows: "5",
                                                    maxlength: _ctx.maxCommentLength
                                                }, null, 8 /* PROPS */, ["modelValue", "maxlength"]),
                                                _cache[25] || (_cache[25] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_19, [
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.getCommentLength(_ctx.editingLog.notes)), 1 /* TEXT */),
                                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                                        _createElementVNode("span", _hoisted_22, "/ " + _toDisplayString(_ctx.maxCommentLength), 1 /* TEXT */)
                                                    ]),
                                                    _cache[24] || (_cache[24] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createElementVNode("div", _hoisted_24, [
                                                            _createVNode(_component_b_button, {
                                                                type: "button",
                                                                variant: "primary",
                                                                onClick: _ctx.update,
                                                                disabled: ((_a = _ctx.editingLog) === null || _a === void 0 ? void 0 : _a.notes) == ''
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                                        _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Save\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick", "disabled"]),
                                                            _cache[22] || (_cache[22] = _createTextVNode()),
                                                            _createVNode(_component_b_button, {
                                                                class: "ms-2",
                                                                type: "button",
                                                                variant: "secondary",
                                                                onClick: _ctx.cancelEditing
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Cancel\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[23] || (_cache[23] = _createTextVNode()),
                                                            _createElementVNode("div", _hoisted_25, [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    class: "ms-2",
                                                                    style: { "padding-top": "8px" },
                                                                    modelValue: log.notifySiteContactGroup,
                                                                    "onUpdate:modelValue": ($event) => ((log.notifySiteContactGroup) = $event),
                                                                    size: "lg"
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNotify\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                                            ])
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                    ])
                                ]));
                            }), 256 /* UNKEYED_FRAGMENT */)),
                            _cache[29] || (_cache[29] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_b_button, {
                                    type: "button",
                                    variant: "secondary",
                                    onClick: _ctx.loadMore,
                                    disabled: !_ctx.hasMoreLogs()
                                }, {
                                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\tLoad more...\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick", "disabled"])
                            ])
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }),
            _cache[35] || (_cache[35] = _createTextVNode()),
            _cache[36] || (_cache[36] = _createTextVNode()),
            _createVNode(_component_StatusOverlayComponent, {
                visible: _ctx.working,
                message: "Wait..."
            }, null, 8 /* PROPS */, ["visible"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onHidden"]));
}
